import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
/* CAT logo — bold mark with iconic triangle accent */
function CatLogo() {
  return <div className="flex items-center gap-2" data-id="element-109">
      <span className="font-sans text-3xl md:text-5xl font-black tracking-tight leading-none" data-id="element-110">
        CAT
      </span>
      <svg viewBox="0 0 24 24" className="w-5 h-5 md:w-7 md:h-7 mt-1" fill="white" data-id="element-111">
        <polygon points="12,2 22,22 2,22" data-id="element-112" />
      </svg>
    </div>;
}
/* PwC logo */
function PwcLogo() {
  return <span className="font-serif text-4xl md:text-5xl italic font-bold lowercase leading-none tracking-tight" data-id="element-113">
      pwc
    </span>;
}
/* team.blue logo — wordmark with dot accent */
function TeamBlueLogo() {
  return <div className="flex items-baseline" data-id="element-114">
      <span className="font-sans text-2xl md:text-3xl font-normal lowercase tracking-tight" data-id="element-115">
        team
      </span>
      <span className="font-sans text-2xl md:text-3xl font-bold lowercase tracking-tight" data-id="element-116">
        .blue
      </span>
    </div>;
}
/* Macmillan logo — classic serif wordmark */
function MacmillanLogo() {
  return <span className="font-serif text-2xl md:text-3xl tracking-tight leading-none" data-id="element-117">
      MACMILLAN
    </span>;
}
const logos = [{
  name: 'CAT',
  Component: CatLogo
}, {
  name: 'PwC',
  Component: PwcLogo
}, {
  name: 'team.blue',
  Component: TeamBlueLogo
}, {
  name: 'Macmillan',
  Component: MacmillanLogo
}];
export function SlideCustomers() {
  return <Slide data-id="element-118">
      <SlideHeader data-id="element-119">Notable Customers</SlideHeader>

      <div className="flex-1 flex flex-col" data-id="element-120">
        {/* Logo Wall */}
        <motion.div variants={itemVariants} className="grid grid-cols-2 md:grid-cols-4 gap-px bg-gray-800 border border-gray-800 mb-20" data-id="element-121">
          {logos.map(({
          name,
          Component
        }) => <div key={name} className="flex items-center justify-center h-28 md:h-36 bg-black px-6" aria-label={name} data-id="element-122">
              <Component data-id="element-123" />
            </div>)}
        </motion.div>

        {/* Big Quote */}
        <motion.div variants={itemVariants} className="max-w-5xl mx-auto text-center mt-auto mb-12" data-id="element-124">
          <p className="text-3xl md:text-5xl lg:text-6xl font-serif leading-[1.1] tracking-tight mb-8" data-id="element-125">
            "Waydev finally gave us the data to prove our $2M Copilot investment
            was actually making engineers faster, not just lazier."
          </p>
          <div className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-126">
            — VP Engineering, Fortune 100 Financial Services
          </div>
        </motion.div>
      </div>
    </Slide>;
}